import { UndyingFuryEffect } from 'game/extended/heros/barbarian/undying_fury/undying_fury_effect'

export default {
    events: {},
    effects: {
        UndyingFuryEffect
    },
    requirements: {}
}
